<div *ngIf="editMode">
  <form [formGroup]="form">
    <app-content-header text="Camper Information"></app-content-header>
    <div *ngIf="showWarning" class="text-center p-mb-1">
      <p class="warning-text">
        Some pet info is not editable. Please contact your camp for any further change.
      </p>
    </div>
    <div class="row no-gutters">
      <div
        class="input-container col"
        style="padding-right: 0.625rem"
      >
        <!-- CBW-784 Names -->
        <span class="input-label">First Name</span>
        <input
          type="text"
          class="input"
          formControlName="firstName"
        />
        <span
          class="error"
          *ngIf="f.firstName.touched && f.firstName.value === ''"
        >Please enter dog's first name.</span>
      </div>
      <div
        class="input-container col"
        style="padding-right: 0.625rem"
      >
        <span class="input-label">Last Name</span>
        <input
          type="text"
          class="input"
          formControlName="lastName"
        />
        <span
          class="error"
          *ngIf="f.lastName.touched && f.lastName.value === ''"
        >Please enter dog's last name.</span>
      </div>
    </div>
    <div class="input-container input-container-box">
      <span class="input-label">Date of Birth</span>
      <div
        class="d-flex dob-container"
        (click)="picker.open()"
        (keyup.Tab)="picker.open()"
      >
        <div style="flex: 1">
          <input
            type="text"
            class="input"
            readonly
            formControlName="dob"
            matInput
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="picker"
          />
          <mat-datepicker
            #picker
            (closed)="setDobTouched()"
          ></mat-datepicker>
        </div>
        <div class="icon-container">
          <img
            src="assets/svg/ico_calendar.svg"
            alt="Search Icon"
            width="19"
          />
        </div>
      </div>
      <span
        class="error"
        *ngIf="isDobTouched && f.dob.value === ''"
      >Please choose a date.</span>
      <span class="input-label italic">Dogs are required to be 4 months old to attend Camp and must be
        spayed/neutered if over 7 months.</span>
    </div>
    <div
      class="input-container input-container-box"
      formArrayName="breedArr"
    >
      <span class="input-label">Breed</span>
      <div
        *ngFor="
          let breed of f.breedArr.controls;
          let i = index;
          let isLastChild = last
        "
        [style.margin-bottom]="!isLastChild ? '0.875rem' : '0'"
      >
        <div class="row no-gutters">
          <div
            class="col d-flex"
            #breedDropdown
          >
            <div style="flex: 1">
              <input
                type="text"
                class="input"
                matInput
                (blur)="blurBreed(i)"
                [formControlName]="i"
                [matAutocomplete]="auto"
                #trigger="matAutocompleteTrigger"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="getBreedLabel"
                (optionSelected)="filterBreedsOption()"
              >
                <mat-option
                  *ngFor="let option of filteredBreeds[i] | async"
                  [value]="option"
                  (mousedown)="$event.preventDefault()"
                >
                  {{ option.label }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div
              class="icon-container"
              (click)="$event.stopPropagation(); trigger.openPanel()"
            >
              <img
                src="assets/svg/ico_arrow_down_teal.svg"
                alt="Arrow Down Icon"
                width="15"
              />
            </div>
          </div>
          <div class="col-auto d-flex">
            <div
              *ngIf="i !== 0"
              class="icon-container trash"
              (click)="removeBreed(i)"
            >
              <img
                src="assets/svg/ico_trash_can.svg"
                alt="Trash Can Icon"
                width="15"
              />
            </div>
          </div>
        </div>
        <span
          class="error"
          [style.width.px]="breedDropdown.offsetWidth"
          *ngIf="breed.touched && breed.value === null"
        >Please select a breed.</span>
      </div>
      <div class="mt-2">
        <app-arrow-link-right
          text="+ Add a Breed"
          (handleClick)="addBreed()"
        ></app-arrow-link-right>
      </div>
    </div>
    <div
      class="input-container input-container-box"
      formArrayName="colorArr"
    >
      <span class="input-label">Color</span>
      <div
        *ngFor="
          let color of f.colorArr.controls;
          let i = index;
          let isLastChild = last
        "
        [style.margin-bottom]="!isLastChild ? '0.875rem' : '0'"
      >
        <div class="row no-gutters">
          <div
            class="col d-flex"
            #colorDropdown
          >
            <div style="flex: 1">
              <input
                type="text"
                class="input"
                matInput
                (blur)="blurColor(i)"
                [formControlName]="i"
                [matAutocomplete]="auto"
                #trigger="matAutocompleteTrigger"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="getColorLabel"
                (optionSelected)="filterColorOption()"
              >
                <mat-option
                  *ngFor="let option of filteredColors[i] | async"
                  [value]="option"
                  (mousedown)="$event.preventDefault()"
                >
                  {{ option.label }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div
              class="icon-container"
              (click)="$event.stopPropagation(); trigger.openPanel()"
            >
              <img
                src="assets/svg/ico_arrow_down_teal.svg"
                alt="Arrow Down Icon"
                width="15"
              />
            </div>
          </div>
          <div class="col-auto d-flex">
            <div
              *ngIf="i !== 0"
              class="icon-container trash"
              (click)="removeColor(i)"
            >
              <img
                src="assets/svg/ico_trash_can.svg"
                alt="Trash Can Icon"
                width="15"
              />
            </div>
          </div>
        </div>
        <span
          class="error"
          [style.width.px]="colorDropdown.offsetWidth"
          *ngIf="color.touched && color.value === null"
        >Please select a color.</span>
      </div>
      <div class="mt-2">
        <app-arrow-link-right
          text="+ Add a Color"
          (handleClick)="addColor()"
        ></app-arrow-link-right>
      </div>
    </div>
    <div class="input-container">
      <span class="input-label">Weight (lbs)</span>
      <input
        type="number"
        min="0"
        class="input"
        formControlName="weight"
        (blur)="blurWeight()"
      />
      <span
        class="error"
        *ngIf="f.weight.touched && !f.weight.value"
      >Please enter weight.</span>
      <span class="input-label italic">Some Camps have weight restrictions for dogs under 10lbs.
        Check with your Camp for details.
      </span>
    </div>
    <div class="input-container">
      <span class="input-label">Gender</span>
      <div class="row">
        <div class="col col-sm-9">
          <app-binary-choice-selector
            [opt1]="genderList[0]"
            [opt2]="genderList[1]"
            [selectedValue]="f.gender.value"
            (selectedValueChange)="setGender($event)"
          ></app-binary-choice-selector>
        </div>
      </div>
    </div>
    <div class="input-container">
      <span class="input-label">Spayed/Neutered</span>
      <div class="row">
        <div class="col col-sm-9">
          <app-binary-choice-selector
            [opt1]="yesNoList[0]"
            [opt2]="yesNoList[1]"
            [selectedValue]="f.spayNeutered.value"
            (selectedValueChange)="f.spayNeutered.setValue($event)"
          ></app-binary-choice-selector>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-5">
      <div
        class="d-flex align-items-center remove-dog-btn"
        (click)="showRemoveDogDialog()"
        (keyup.enter)="showRemoveDogDialog()"
        tabindex="0"
      >
        <img
          src="assets/images/ico_remove camper.png"
          width="20"
        />
        <span
          class="oswald critical ml-2"
          style="font-size: 0.875rem"
          title="Remove This Dog"
        >Remove Camper</span>
      </div>
    </div>
    <hr />
    <footer class="footer-action">
      <button
        type="button"
        class="btn btn-danger btn-block"
        [disabled]="!form.valid"
        (click)="onSave()"
      >
        Save
      </button>
    </footer>
  </form>
</div>

<div *ngIf="!editMode">
  <app-content-header
    text="Camper Information"
    [showEdit]="true"
    (editClicked)="editMode = true"
    firebase="dogProfile_editCamperDetails"
  ></app-content-header>
  <div class="row">
    <div class="col view-container">
      <div class="view-label">Dog Name</div>
      <!-- CBW-784 Names -->
      <span>{{ f.firstName.value + " " + f.lastName.value }}</span>
      <hr class="view-divider" />
    </div>
  </div>
  <div class="row">
    <div class="col view-container">
      <div class="view-label">Date of Birth</div>
      <span>{{ f.dob.value | date }}</span>
      <hr class="view-divider" />
    </div>
  </div>
  <div class="row">
    <div class="col view-container">
      <div class="view-label">Breed</div>
      <ng-container *ngFor="let breed of f.breedArr.controls">
        <span>{{ breed.value?.label }}</span>
        <hr class="view-divider" />
      </ng-container>
    </div>
  </div>
  <div class="row">
    <div class="col view-container">
      <div class="view-label">Color</div>
      <ng-container *ngFor="let color of f.colorArr.controls">
        <span>{{ color.value?.label }}</span>
        <hr class="view-divider" />
      </ng-container>
    </div>
  </div>
  <div class="row">
    <div class="col view-container">
      <div class="view-label">Weight (lbs)</div>
      <span>{{ f.weight.value }}</span>
      <hr class="view-divider" />
    </div>
  </div>
  <div class="row">
    <div class="col view-container">
      <div class="view-label">Gender</div>
      <span>{{ genderText }}</span>
      <hr class="view-divider" />
    </div>
  </div>
  <div class="row">
    <div class="col view-container">
      <div class="view-label">Spayed/Neutered</div>
      <span>{{ getYesNoText(f.spayNeutered.value)  }}</span>
      <hr class="view-divider" />
    </div>
  </div>
</div>
